<header
  class="h-12 bg-whiteshade dark:bg-blacker border-borders-light dark:border-borders-darker border-b flex justify-between items-center pr-2 sm:pr-6"
>
  <a
    href="#"
    (click)="scrollToTop($event)"
    (keyup)="onKeyUp($event, 'scroll')"
    tabindex="0"
    aria-label="Scroll to top"
    class="absolute inset-0 z-0"
  ></a>

  <div class="z-10 w-full pl-3 flex justify-between items-center add-work">
    <div class="w-[70%] flex gap-4 justify-start">
      <button
        (click)="openModal('addWork')"
        (keyup)="onKeyUp($event, 'addWork')"
        class="w-full max-w-full! add btn btn-secondary btn-add icon-search text-[16px]! text-left! rounded-full!"
      >
        <span class="justify-start!">{{ "SEARCH_WORKS" | translate }}</span>
      </button>
    </div>
    <div class="flex justify-between align-center">
      @if (user) {
      <app-discussions-button class="mr-4 mt-[6px]"></app-discussions-button>
      <app-notifications
        class="notifications mr-4"
        [user]="user"
      ></app-notifications>
      }
      <app-profile-menu class="profile" [user]="user"></app-profile-menu>
    </div>
  </div>
</header>
